import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { BillingConfigTemplate } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BillingConfigTemplatesService {

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
  ) {}

  find(query = ''): Observable<HttpResponse<BillingConfigTemplate[]>> {
    return this.http
      .get<BillingConfigTemplate[]>(`${environment.API_URL}/billing-config-templates${query}`, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }

  findById(id: string): Observable<HttpResponse<BillingConfigTemplate>> {
    return this.http
      .get<BillingConfigTemplate>(`${environment.API_URL}/billing-config-templates/${id}`, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }

  create(body: Partial<BillingConfigTemplate>): Observable<HttpResponse<BillingConfigTemplate>> {
    return this.http
      .post<BillingConfigTemplate>(`${environment.API_URL}/billing-config-templates`, body, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }

  update(id: string, body: Partial<BillingConfigTemplate>): Observable<HttpResponse<BillingConfigTemplate>> {
    return this.http
      .patch<BillingConfigTemplate>(`${environment.API_URL}/billing-config-templates/${id}`, body, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }

  delete(id: string): Observable<HttpResponse<any>> {
    return this.http
      .delete(`${environment.API_URL}/billing-config-templates/${id}`, { observe: 'response' })
      .pipe(
        map(r => r),
        catchError(e => { this.errorService.handleError(e); throw e; })
      );
  }
}
